import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Input, Radio } from 'antd'
import { DatePickerF, SelectF } from '@/i2antdV5'
import { fetchJStoreList } from '@/redux/components/getJStoreListSlice'
import { TUINA_GENDER_OPTIONS } from '@/views/tuina/options'

const FormItem = Form.Item

class MemberForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    actType: PropTypes.oneOf(['create', 'edit']),
    record: PropTypes.object,
    storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    getJStoreList: PropTypes.object,
    memberList: PropTypes.object,
    dispatch: PropTypes.func
  }

  componentDidMount () {
    const { dispatch, getJStoreList } = this.props
    const storeOptions = getJStoreList.data
    if (!Array.isArray(storeOptions) || storeOptions.length === 0) {
      dispatch(fetchJStoreList({ query: {}, dataType: 'optionTuina' }))
    }
    this.syncRecord()
  }

  componentDidUpdate (prevProps) {
    const prevId = prevProps.record && prevProps.record.id
    const nextId = this.props.record && this.props.record.id
    if (
      prevProps.actType !== this.props.actType ||
      prevId !== nextId ||
      prevProps.storeId !== this.props.storeId
    ) {
      this.syncRecord()
      return
    }
    const prevList = prevProps.getJStoreList.data
    const nextList = this.props.getJStoreList.data
    const prevEmpty = !Array.isArray(prevList) || prevList.length === 0
    const nextHas = Array.isArray(nextList) && nextList.length > 0
    if (prevEmpty && nextHas) this.syncRecord()
  }

  syncRecord = () => {
    const { form, actType, record, storeId, memberList, getJStoreList } = this.props
    if (!form || !form.current) return
    const storeOptions = getJStoreList.data
    const firstStore = Array.isArray(storeOptions) && storeOptions[0]
    const firstStoreId = firstStore && firstStore.id != null && firstStore.id !== ''
      ? String(firstStore.id)
      : undefined
    const values = {
      gender: 0,
      storeId: firstStoreId
    }
    const queryStoreId = memberList.query.storeId
    if (queryStoreId != null && queryStoreId !== '') {
      values.storeId = String(queryStoreId)
    }
    if (storeId != null && storeId !== '') {
      values.storeId = String(storeId)
    }
    if (actType === 'edit' && record) {
      values.storeId = record.storeId == null || record.storeId === ''
        ? undefined
        : String(record.storeId)
      values.name = record.name
      values.phone = record.phone
      values.gender = record.gender ?? 0
      values.birthday = record.birthday
    }
    form.current.setFieldsValue(values)
  }

  render () {
    const { form, actType, getJStoreList } = this.props
    const storeOptions = getJStoreList.data
    return (
      <Form ref={form} layout="vertical">
        <FormItem
          label="门店"
          name="storeId"
          rules={[{ required: true, message: '请选择门店' }]}
        >
          <SelectF
            options={storeOptions}
            modalProps={{
              size: 'large',
              placeholder: '请选择门店',
              disabled: actType === 'edit'
            }}
          />
        </FormItem>
        <FormItem
          label="姓名"
          name="name"
          rules={[{ required: true, message: '请填写姓名' }]}
        >
          <Input size="large" placeholder="如 张三" />
        </FormItem>
        <FormItem
          label="手机号"
          name="phone"
          rules={[{ required: true, message: '请填写手机号' }]}
        >
          <Input
            size="large"
            placeholder="会员手机号"
          />
        </FormItem>
        <FormItem
          label="性别"
          name="gender"
          rules={[{ required: true, message: '请选择性别' }]}
        >
          <Radio.Group size="large" optionType="button" buttonStyle="solid">
            {TUINA_GENDER_OPTIONS.map((item) => (
              <Radio.Button key={item.id} value={item.id}>{item.value}</Radio.Button>
            ))}
          </Radio.Group>
        </FormItem>
        <FormItem
          label="生日"
          name="birthday"
          rules={[{ required: true, message: '请选择生日' }]}
        >
          <DatePickerF
            dateStrValue
            modalProps={{
              size: 'large',
              allowClear: false,
              format: 'YYYY-MM-DD',
              placeholder: '请选择生日',
              style: { width: '100%' },
              getPopupContainer: () => document.body,
              popupStyle: { zIndex: 1200 }
            }}
          />
        </FormItem>
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  getJStoreList: state.components.getJStoreList,
  memberList: state.tuina.memberList
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(MemberForm)
